import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showDocumentation } from 'modules/documentation';
import styles from './styles/index.scss';
import { PropTypes } from 'helpers/react';
const { func, string, objectOf, children } = PropTypes;

@connect(null, { showDocumentation })
export default class DocumentationLink extends Component {
  static propTypes = {
    src: string,
    component: string,
    showDocumentation: func,
    style: objectOf(string),
    children: children
  };

  static defaultProps = {
    component: 'a'
  };

  showDocumentation = event => {
    const { src, showDocumentation } = this.props;
    event.stopPropagation();
    showDocumentation(src);
  };

  render() {
    const { component, style } = this.props;
    const CustomTag = component;
    return (
      <CustomTag
        onClick={this.showDocumentation}
        className={styles['link']}
        style={style}
      >
        {this.props.children}
      </CustomTag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/DocumentationLink/index.js